export default __webpack_public_path__ + "static/media/get_started_today_button.14f36c3f.svg";